import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { Job } from '../model/job';
import { HttpClient } from '@angular/common/http';
import { JobPositionSerializer } from '@app/model/serializer/job-position-dto-serializer';
import { JobPositionDTO } from '@app/model/jobPositionDTO';
import { environment } from '@environments/environment';



@Injectable({ providedIn: 'root' })
export class JobPositionService extends ApiService<JobPositionDTO> {

  constructor(httpClient: HttpClient) {
    super(httpClient,
        environment.apiUrl,
      'job',
      new JobPositionSerializer());
  }
}
